module.exports = __webpack_public_path__ + "img/jibs_cranes.4cafd6f9.jpg";